import { useEffect, useRef } from 'react'

interface Options {
  hasNextPage: boolean
  isFetchingNextPage: boolean
  fetchNextPage: () => void
  /** 提前多少像素触发 */
  rootMargin?: string
}

/** 把返回的 ref 挂到列表末尾的哨兵元素上。 */
export function useInfiniteScroll({
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
  rootMargin = '600px',
}: Options) {
  const sentinelRef = useRef<HTMLDivElement>(null)
  // 用 ref 存回调，避免每次 render 重建 observer
  const fetchRef = useRef(fetchNextPage)
  fetchRef.current = fetchNextPage

  useEffect(() => {
    const node = sentinelRef.current
    if (!node || !hasNextPage || isFetchingNextPage) return

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) fetchRef.current()
      },
      { rootMargin },
    )
    observer.observe(node)
    return () => observer.disconnect()
  }, [hasNextPage, isFetchingNextPage, rootMargin])

  return sentinelRef
}
